module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDUuNjUgNzAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojYzIzMzM0O308L3N0eWxlPjwvZGVmcz48dGl0bGU+cm9qYTwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNDUuNjUiIGhlaWdodD0iNzAiIHJ4PSI1LjczIiByeT0iNS43MyIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/redCard.svg
// module id = +X1f
// module chunks = 94